import { ChecklistBreadcrumb, splitBookSegment } from '../ChecklistBoard/ChecklistBreadcrumb'
import type { ChecklistBreadcrumbSegment } from '../../utils/checklistBreadcrumb'
import type { ChecklistParentSaveOutcome } from '../../types/checklistDetailController'
import type { ParentPickerContext } from '../ChecklistBoard/ParentPickerPopover'

export const getNodeDetailLocationBreadcrumbSegments = (
  segments: ChecklistBreadcrumbSegment[],
): ChecklistBreadcrumbSegment[] => splitBookSegment(segments).rest

type NodeDetailLocationBreadcrumbProps = {
  segments: ChecklistBreadcrumbSegment[]
  className?: string
  editable?: boolean
  onReparent?: (
    nextParentId: string | null,
    opts?: { window?: { start: string; end: string } | null },
  ) => Promise<ChecklistParentSaveOutcome>
  parentPickerContext?: ParentPickerContext
}

export const NodeDetailLocationBreadcrumb = ({
  segments,
  className,
  editable = false,
  onReparent,
  parentPickerContext,
}: NodeDetailLocationBreadcrumbProps) => {
  const locationSegments = getNodeDetailLocationBreadcrumbSegments(segments)
  if (locationSegments.length === 0 && !editable) return null

  return (
    <ChecklistBreadcrumb
      segments={locationSegments}
      className={className}
      editable={editable}
      onReparent={onReparent}
      parentPickerContext={parentPickerContext}
    />
  )
}
